import React from 'react';
import Txt from 'components/atoms/Txt/Txt';
import classes from './OtherOffers.module.scss';
import { CategoryOption } from 'components/molecules/CategoryOptionsModal/CategoryOptionsModal';
import SearchingOinq from 'components/assets/oinq/SearchingOinq.svg';
import clsx from 'clsx';
import type { OfferType } from 'utils/offers';

export interface OtherOffersProps {
  categories: CategoryOption[];
  onCategorySelect: (tag: string) => void;
  currentCategory?: string;
  className?: string;
  offerType?: OfferType;
}

const OtherOffers: React.FC<OtherOffersProps> = ({
  categories,
  onCategorySelect,
  currentCategory,
  className,
  offerType = 'cashback',
}) => {
  const availableCategories = categories.filter(
    (cat) => cat.tag !== currentCategory && cat.count !== undefined && cat.count > 0,
  );

  if (availableCategories.length === 0) {
    return null;
  }

  return (
    <div className={clsx(classes.root, className)}>
      <div className={classes.header}>
        <Txt component="p" className={classes.title} bold>
          Check out some of the many other offers we have available...
        </Txt>
        <div className={classes.icon}>
          <SearchingOinq width={130} height={115} />
        </div>
      </div>

      <div className={classes.categoryGrid}>
        {availableCategories.map((category) => (
          <button
            key={category.tag}
            className={classes.categoryButton}
            onClick={() => onCategorySelect(category.tag)}
          >
            <Txt className={classes.categoryName} skipTranslation>
              {category.name}
            </Txt>
            {category.count !== undefined && (
              <span className={classes.categoryCount}> ({category.count})</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default OtherOffers;
